import localForage from "localforage";
import { deflateSync, inflateSync, strFromU8, strToU8 } from "fflate";
import { isNil } from "lodash-es";

export type CompressedStorage = {
  getItem: (key: string) => Promise<string | null>;
  setItem: (key: string, value: string) => Promise<void>;
  removeItem: (key: string) => Promise<void>;
};

const createCompressedStorage = (): CompressedStorage => {
  const setItem = async (key: string, value: string) => {
    const uncompressedBytes = strToU8(value);
    const compressedBytes = deflateSync(uncompressedBytes);
    await localForage.setItem(key, compressedBytes);
  };

  const getItem = async (key: string) => {
    const compressedBytes = await localForage.getItem<Uint8Array>(key);
    if (isNil(compressedBytes)) {
      return null;
    }

    const decompressedBytes = inflateSync(compressedBytes);
    return strFromU8(decompressedBytes);
  };

  const removeItem = (key: string) => localForage.removeItem(key);

  return { getItem, setItem, removeItem };
};

export default createCompressedStorage;
